document.addEventListener('keyup', function (e) {
  if (e.key !== 'Enter' && e.keyCode !== 13) return;

  var target = e.target;
  if (!(target instanceof HTMLInputElement)) return;

  if (!target.matches('input[data-input-search], input.t4s-mini-search__input')) return;

  var query = (target.value || '').trim();
  if (!query) return;

  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }
  e.stopPropagation();
  e.preventDefault();

  var url = '/search?type=product'
    + '&options[unavailable_products]=last'
    + '&options[prefix]=last'
    + '&q=' + encodeURIComponent(query);

  window.location.assign(url);
}, true); 